'use strict';
import * as $j_app$002edata$002etypes$005fgeneral$0024package$0024$002dApp$002dBuild$002dTime$0024 from "./app.data.types_general$package$-App-Build-Time$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$89() {
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$89 as $c_Lapp_api_PharmacyAppUpdate$$anon$89 };
$c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$89;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$89() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$89 as $h_Lapp_api_PharmacyAppUpdate$$anon$89 };
$h_Lapp_api_PharmacyAppUpdate$$anon$89.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy59 = $j_app$002edata$002etypes$005fgeneral$0024package$0024$002dApp$002dBuild$002dTime$0024.$m_Lapp_data_types\uff3fgeneral$package$AppBuildTime$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy59, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
});
$c_Lapp_api_PharmacyAppUpdate$$anon$89.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$89 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$89, "app.api.PharmacyAppUpdate$$anon$89", ({
  Lapp_api_PharmacyAppUpdate$$anon$89: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$89 as $d_Lapp_api_PharmacyAppUpdate$$anon$89 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$89.js.map
